let accessToken: string | null = null

export const oauthAccessToken = {
    get: () => accessToken,
    set: (token: string) => {
        accessToken = token
    },
    clear: () => {
        accessToken = null
    },
}
